(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    



  (() => {

    if (window.rejsellFeatureDisclosureInstalled) return;

    window.rejsellFeatureDisclosureInstalled = true;

    let nextId = 0;

    document.addEventListener('click', event => {

      if (!(event.target instanceof Element)) return;

      const button = event.target.closest('.rejsell-feature-toggle');

      if (!button) return;

      const panel = button.nextElementSibling;

      if (!panel?.classList.contains('rejsell-feature-panel')) return;

      event.preventDefault();

      event.stopPropagation();

      if (!panel.id) {

        do { nextId++; } while (document.getElementById('rejsell-feature-panel-' + nextId));

        panel.id = 'rejsell-feature-panel-' + nextId;

      }

      button.setAttribute('aria-controls', panel.id);

      const expanded = button.getAttribute('aria-expanded') !== 'true';

      button.setAttribute('aria-expanded', String(expanded));

      panel.setAttribute('aria-hidden', String(!expanded));

      panel.classList.toggle('is-open', expanded);

    }, true);

    document.addEventListener('keydown', event => {

      if (event.target instanceof Element && event.target.closest('.rejsell-feature-toggle') &&

          (event.key === 'Enter' || event.key === ' ')) event.stopPropagation();

    }, true);

  })();




  } catch(e) { console.error(e); }
})();
})();
